export default __webpack_public_path__ + "static/pheni-6e960132fbcc58573985133a501b40d5.png";